/*
    checkNewsAndSetRedDot gets passed the currentNewsId - this is the largest id number that we currently have for the product in question in our database
    We will first ask the database for the highest id number for Cumulus, etc. and then pass that to this function
    It will check to see if a cookie exists at all, if not, it will create one and assume the user has not viewed the news - and thus sets the red dot to true
    If the cookie exists, it will compare the user's last seen id number to the largest available in the db
    If the id number they last saw is less than the largest one available, there's new news so show the red dot
*/
export function checkNewsAndSetRedDot(currentNewsId: number) {
    const getCookie = (name: string): string | null => {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    };
  
    const setCookie = (name: string, value: string, days = 365) => {
      const expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
    };
  
    let lastSeenNewsId = parseInt(getCookie('lastSeenNewsId') ?? '0', 10);
  
    // Ensure the cookie exists
    if (!getCookie('lastSeenNewsId')) {
      setCookie('lastSeenNewsId', '0');
      lastSeenNewsId = 0;
    }
  
    if (lastSeenNewsId === 0 || lastSeenNewsId < currentNewsId) {
      setCookie('showRedDot', 'true');
    } 
    
    else {
      setCookie('showRedDot', 'false');
    }
}

/*
    setLastSeenNewsId is going to be called when the user lands on the news page
    We will pass the largest available news id number for the product in question so that the view news record gets updated
    At this point, the user does not have new news so the dot will go away
*/
export function setLastSeenNewsId(newsId: number) {
    const setCookie = (name: string, value: string, days = 365) => {
      const expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;

      console.log("document.cookie: ", document.cookie);
    };
  
    console.log("Inside setLastSeenNewsId");

    setCookie('lastSeenNewsId', newsId.toString());
    setCookie('showRedDot', 'false');
}

export function getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
};